export enum ActionTrack {
  PATIENT_CARD_OPENED = "Patient Card Opened",
  SUGGESTION_ACTION = "Suggestion Action",
  EDD_INTERACTION = "EDD Interaction",
  DISPOSITION_INTERACTION = "Disposition Interaction",
  INSIGHTS_POSITIVE_FEEDBACK_RECEIVED = "Insights Positive Feedback Received",
  INSIGHTS_NEGATIVE_FEEDBACK_RECEIVED = "Insights Negative Feedback Received",
  INSIGHTS_FEEDBACK_REMOVED = "Insights Feedback Removed",
  ROUNDING_SESSION_STARTED = "Rounding Session Started",
  ROUNDING_SESSION_ENDED = "Rounding Session Ended",
  ROUNDING_SESSION_PATIENT_REVIEWED = "Rounding Session Patient Reviewed",
  ROUNDING_SESSION_PATIENT_UNREVIEWED = "Rounding Session Patient Marked as Un-reviewed",
}
